import { useCallback } from "react";
import { toast } from "react-toastify";
import { usePatientAuthFlags } from "./usePatientAuthFlags";
import {
  CRE_PERMISSION_DENIED_MESSAGE,
  hasCrePermission,
} from "../cre/crePermissions";

/**
 * CRE Web App permission gate.
 * Non-CRE auth: always allowed (Radical uses its own rules).
 */
export function useCrePermission() {
  const { isCreAuth, creUser } = usePatientAuthFlags();

  const can = useCallback(
    (code) => {
      if (!isCreAuth) return true;
      return hasCrePermission(creUser, code);
    },
    [isCreAuth, creUser],
  );

  /**
   * If CRE user lacks permission: toast and return false (do not open module).
   * Non-CRE: always true.
   */
  const requirePermission = useCallback(
    (code) => {
      if (!isCreAuth) return true;
      if (hasCrePermission(creUser, code)) return true;
      toast.info(CRE_PERMISSION_DENIED_MESSAGE);
      return false;
    },
    [isCreAuth, creUser],
  );

  return { isCreAuth, can, requirePermission, creUser };
}
